import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { massopsRouter } from './routing/massopsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import FR_FR from './translations/fr-FR.json'
import ES_ES from './translations/es-ES.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { massopsAccessControl } from './access-control/massopsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'massops',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'massops-dashboard-tool',
  },
  routes,
  translations: { EN_US, FR_FR, ES_ES },
  routers: {
    admin: [massopsRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.MarketplaceOps,
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'massops-interventions',
          labelId: 'massopsDomain.interventions.title',
          accessControl: massopsAccessControl,
        },
      ],
    },
  ],
}

export default definition
